import { createApi } from "@reduxjs/toolkit/query/react";
import { AgentStateDto } from "../../models/agent";
import { apiBaseQuery, post, put } from "../queryHelpers";

export interface BusinessUnit {
  id: string;
  enabled: boolean;
  name?: string;
}

const blenderApi = createApi({
  reducerPath: "blenderApi",
  tagTypes: ["BusinessUnits"],
  baseQuery: apiBaseQuery("/blender"),
  endpoints: builder => ({
    getAgentState: builder.query<AgentStateDto, void>({
      query: () => "/resource/getstate",
    }),
    login: builder.mutation<void, void>({
      query: () => post("/resource/login?mobileSession=true", {}),
    }),
    logout: builder.mutation<void, void>({
      query: () => post("/resource/logout", {}),
    }),
    goToAvailable: builder.mutation<void, void>({
      query: () => post("/resource/activate", {}),
    }),
    getBreakNames: builder.query<string[], void>({
      query: () => "/resource/breakNames",
    }),
    goToBreak: builder.mutation<void, string | null>({
      query: breakName => post(`/resource/moveToBreak?breakName=${breakName ?? ""}`, {}),
    }),
    getBusinessUnits: builder.query<BusinessUnit[], void>({
      query: () => "/resource/businessUnits",
      providesTags: ["BusinessUnits"],
    }),
    updateBusinessUnits: builder.mutation<void, BusinessUnit>({
      query: businessUnits => put("/resource/businessUnits", [businessUnits]), // manually map to array because the API could actually handle more than one BU change at a time
      invalidatesTags: ["BusinessUnits"],
    }),
  }),
});

export const {
  useGetAgentStateQuery,
  useLoginMutation,
  useLogoutMutation,
  useGoToAvailableMutation,
  useGetBreakNamesQuery,
  useLazyGetBreakNamesQuery,
  useGoToBreakMutation,
  useGetBusinessUnitsQuery,
  useUpdateBusinessUnitsMutation,
} = blenderApi;

export default blenderApi;
